module.exports = __webpack_public_path__ + "static/media/contact_me.b7c66b35.jpg";